import { Enums } from "../models/common/enums"

import { ConfigHelper } from "./config-helper"
import { IUserSession } from "./user-session"
import { OperatorLayoutSetting } from "../models/local"
import * as _ from 'underscore'

export type ThemeConfiguration = {
    backgroundColor: string
    defaultFontColor: string
    linkColor: string
    linkHoverColor: string
    headerBGColor: string
    headerTextColor: string
    dashboardPanelColor: string
    dashboardPanelBGColor: string
    dashboardPanelBorderColor: string
    dashboardPanelFontWeight: string
    sidebarBGColor: string
    sidebarFontColor: string
    sidebarHoverFontColor: string
    sidebarHoverBGColor: string
    sidebarActiveFontColor: string
    sidebarActiveBGColor: string
    burgerWrapperBGColor: string
    burgerTextColor: string
    burgerBGColor: string
    burgerHoverTextColor: string
    burgerHoverBGColor: string
    slickButtonsColor: string
    slickNextPrevButtonColor: string
    evenFieldBGColor: string
    propertyTextColor: string
    headerAccordionColor: string
    measurementBackgroundColor: string
    dashboardTitleTextColor: string
    dashboardTitleBGColor: string
    dashboardTileTextColor: string
    dashboardTileBGColor: string
    dashboardCardBGColor: string
    loginBGColor: string
    loginFormControlBGColor: string
    loginFormControlShadow: string
    loginFormControlFocusBorderColor: string
    loginFormControlColor: string
    loginCopyrightColor: string
    loginButtonColor: string
    loginButtonBGColor: string
    buttonBlueBGColor: string
    cookieBannerBGColor: string
    cookieBannerBlueTransparentBGColor: string
    cookieBannerColor: string
    customBorderColor: string
    customFocusedRow: string
    definitionTemplateTextColor: string
    trackingGridBackground: string
    filterBarHoverColor: string
    statusRunningColor: string
    statusOkColor: string
    statusErrorColor: string
    defaultBorderColor: string
    scheduleSelectedDay: string
    scheduleOn: string
    scheduleOff: string
    scheduleBorder: string
    checkBoxBorderColor: string
    iconFillColor: string
}

export type Theme = {
    name: string,
    caption: string,
    mainColor: string,
    backColor: string,
    fillColor: string,
    defaultFontColor: string,
    defaultBackgroundColor: string,
    defaultBorderColor: string,
    iconSize: {
        0: number,
        1: number,
        2: number
    }
}

export class ThemeHelper {

    public static getTheme(userSession: IUserSession): Theme {
        const defaultTheme: string = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.Themes).name
        let selectedTheme: string = null
        if (userSession != null) {
            selectedTheme = userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Theme), defaultTheme)
        }
        const themeToUse: string = this.isThemeAvailable(selectedTheme) ? selectedTheme : defaultTheme

        return ConfigHelper.getValue(Enums.SimaxConfigSection.Themes, themeToUse)
    }

    private static isThemeAvailable(themeName: string): boolean {
        const themes: Theme[] = ConfigHelper.getSectionValue(Enums.SimaxConfigSection.Themes)

        return _.find(themes, (theme: Theme) => theme.name === themeName) != null
    }

}